module.exports = ":root{--lui-taglist-border-color:var(--lui-gray);--lui-taglist-background-color:var(--lui-white);--lui-taglist-max-width:none;--lui-taglist-min-width:100%}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tagfield/theme/lui-taglist.global.scss
// module id = 359
// module chunks = 0 1 4